import { apiClient } from './client';

interface FeedbackData {
    rating: number;
    text: string;
}

interface FeedbackResponse {
    id: string;
    rating: number;
    text: string;
    created_at: string;
}

export const feedbackApi = {
    sendFeedback: async (data: FeedbackData): Promise<FeedbackResponse> => {
        const response = await apiClient.post<FeedbackResponse>('/feedback/', data);
        return response as unknown as FeedbackResponse;
    },
};
